import { render } from "./device-details-header.vue?vue&type=template&id=997d491e&ts=true"
import script from "./device-details-header.ts?vue&type=script&lang=ts"
export * from "./device-details-header.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__